import { mapActions, mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'DataTableSearchPaginatedMixin',

  props: {
    api: String
  },

  data () {
    return {
      items: [],
      itemsCount: 0,
      searchTxt: '',
      searchTxtInput: '',
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        mustSort: true
      }
    }
  },

  created: function () {
    // Tune options: lastUser activity > configuration > defaults
    // The lastUser activity are recovered from localStorage when the dataTable is created
    const route = this.dumpRoute
    const userLastActivity = this.userActivities(route) || {}

    let lastActivityItemsPerPage = userLastActivity.itemsPerPage
    // TODO: to avoid performance issues we are forcing the reset of the pageSize instead of applying "ALL" from the userActivity persistency;
    // the user will still be able to set ALL if it's really what is needed.
    if (lastActivityItemsPerPage === -1 && this.searchTxt === '' && !userLastActivity.filter?.id) {
      lastActivityItemsPerPage = undefined
      console.debug('Performance optimization: avoid page size "ALL" on table mount when no query/filter set')
    }

    this.options.itemsPerPage = lastActivityItemsPerPage || (this.dataTableConfiguration?.itemsPerPage ? this.dataTableConfiguration.itemsPerPage : this.options.itemsPerPage)
    this.options.sortBy = userLastActivity.sortBy || (this.dataTableConfiguration ? this.dataTableConfiguration.sortBy : this.sortBy)
    this.options.sortDesc = userLastActivity.sortDesc || (this.dataTableConfiguration ? this.dataTableConfiguration.sortDesc : this.sortDesc)

    if (this.changeView && typeof this.changeView === 'function') {
      this.changeView(userLastActivity.view)
    }
    // search used to do the search
    this.searchTxt = userLastActivity.search
    // search shown to the user
    this.searchTxtInput = userLastActivity.search
    this.applyFilter(userLastActivity.filter)
  },

  mounted: function () {
    this.fetchData()
  },
  computed: {
    ...mapGetters({
      useDarkColors: 'userDataStore/useDarkColors'
    })
  },
  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'notifyWarning': 'notificationStore/notifyWarning',
      'removeMessage': 'notificationStore/removeMessage',
      'notifyUserConfirm': 'notificationStore/notifyUserConfirm'
    }),

    fetchData () {
      if (this.mode === 'insert' || this.mode === 'edit' || this.mode === 'view') return

      if (!this.loading && !this.isDashboardView) {
        // loading flag check is to prevent double fetch
        // from DataTablePaginated.watch and DataTable.mount
        this.loading = true
        const url = this.searchApi
        const body = Configuration.datatable.paginatedRequestBody(this.dataTableConfiguration, this.options, this.searchTxt, this.filterArray, this.filterHeaders)
        const config = this.$axios.agilisRequestConfig(url)
        this.$axios
          .post(url, body, config)
          .then(async (response) => {
            const responseItems = Array.isArray(response.data) ? response.data : response.data.items
            const items = this.decorateItems(responseItems, this.useDarkColors)

            const runOptimizationWorkaround = !this.isKanbanView && items.length > 100
            if (runOptimizationWorkaround && this.options.itemsPerPage === -1) {
              // on itemsPerPage = "ALL" prevent preformance issues by notifying the
              // what will happen to the user: the advice is to split in pages
              //
              // TODO: why we are not using infinite scroll with v-lazy or virtual-scroll?
              // Because are not compatible with v-data-table: it would mean to re-implement
              // all the v-data-table features on our own! We will reconsider in future: with
              // Vue3 support things might change: https://github.com/vuetifyjs/vuetify/issues/3435
              const userResponse = await this.notifyUserConfirm({
                title: this.$t('label.dataTablePerformanceHeader'),
                messages: [
                  this.$t('label.dataTablePerformance', { itemsLength: items.length })
                ],
                confirm: this.$t('label.dataTablePerformancePaginate'),
                cancel: this.$t('label.dataTablePerformanceContinue')
              })
              if (userResponse === false) {
                this.notifyWarning({
                  message: this.$t('label.dataTablePerformanceWaiting'),
                  hideClose: true
                })

                setTimeout(() => {
                  this.items = items
                  this.itemsCount = response.data.totalItems
                  this.loading = false
                  this.removeMessage()
                }, 0)
              } else {
                this.loading = false
                this.options.itemsPerPage = 15
              }
            } else { // Regular flow: apply results
              this.items = items
              this.itemsCount = response.data.totalItems
              this.loading = false
            }
          })
          .catch((error) => {
            this.notifyError(error)
            this.loading = false
          })
      }
    },

    handleSearchTxtInput (event) {
      if (event.keyCode === 13) {
        this.searchTxt = this.searchTxtInput
        this.options.page = 1
        this.fetchData()
        // save lastUser search
        this.dumpUserAction({ search: this.searchTxt })
      }
    },

    handleSearchLensInput (event) {
      this.searchTxt = this.searchTxtInput
      this.options.page = 1
      this.fetchData()
      this.dumpUserAction({ search: this.searchTxt })
    },

    handleSearchClearInput (event) {
      this.searchTxt = ''
      this.searchTxtInput = ''
      this.options.page = 1
      this.fetchData()
      this.dumpUserAction({ search: this.searchTxt })
    }
  }
}
